define.alias("shared/components/shared/profile-avatar", "settings/components/shared/profile-avatar");